"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _mergeWithCollectionOfType = _interopRequireDefault(require("settings-ui-sdk/utils/mergeWithCollectionOfType"));

var _actions = require("./actions");

var _CanSpamSetting = _interopRequireDefault(require("./CanSpamSetting"));

var _handleActions;

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchCanSpamSettingsActionTypes.SUCCESS, function (state, action) {
  return (0, _mergeWithCollectionOfType.default)(_CanSpamSetting.default, action.payload.data.objects, state);
}), (0, _defineProperty2.default)(_handleActions, _actions.CreateCanSpamSettingActionTypes.SUCCESS, function (state, action) {
  return state.set(action.payload.data.id, new _CanSpamSetting.default(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateCanSpamSettingActionTypes.SUCCESS, function (state, action) {
  return state.set(action.payload.data.id, new _CanSpamSetting.default(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.DeleteCanSpamSettingActionTypes.SUCCESS, function (state, action) {
  return state.remove(action.payload.props.id);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;